import requestAPI from './instance'

/**
 * @description Promise to get user
 * @returns {Promise} The Promise object
 */
export const getUser = async () => {
  return await requestAPI.get(`/whoami`)
}
